import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import { ACCOUNT_LIST } from '../../components/Query';
import SettingsDetailComponent from './SettingsDetailComponent';
import { Loading } from '../../components/Loading';
import { AccountContext } from '../../components/AccountContext';
import { NotificationContext } from '../../components/GrowlNotifications';
import { growlErrors } from '../../utils/NotificationUtil';

const getEdgeForCurrentAccount = (edges, currentAccountId) => {
  let edgeForCurrentAccount;

  edges.forEach((edge) => {
    const accountId = edge.node.id;

    if (accountId === currentAccountId) {
      edgeForCurrentAccount = edge;
    }
  });

  return edgeForCurrentAccount;
};

const SettingsComponent = () => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  return (
    <Query query={ACCOUNT_LIST} variables={{ first: 100 }}>
      {({ loading, error, data }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
        }

        const { accounts } = data.viewer;
        const { edges } = accounts;

        const edgeForCurrentAccount = getEdgeForCurrentAccount(edges, currentAccount);

        const viewerRole = edgeForCurrentAccount.role;
        const accountDisplayName = edgeForCurrentAccount.node.displayName;
        const { scopes } = edgeForCurrentAccount;

        return (
          <SettingsDetailComponent
            viewerRole={viewerRole}
            scopes={scopes}
            accountDisplayName={accountDisplayName}
          />
        );
      }}
    </Query>
  );
};


export default SettingsComponent;
